import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { AiCloseLoopSection } from "./ai-close-loop-section"

export function CloseLoopPage() {
	return (
		<>
			<MetaInfo title="Close Loop Settings" />

			<SettingsHeader
				title="Close loop"
				subtitle="Follow-ups for the customers who asked, sent once their Linear issue or project ships."
			/>

			<AiCloseLoopSection />
		</>
	)
}
